module.exports = __webpack_public_path__ + "static/media/study 211119.c9c47b99.png";